import { useTranslation } from 'react-i18next';
import type { MatchInfo } from '../types/lotto';
import type { GameRules } from '../lib/lotto';
import { formatMatchDate, isJackpotMatch } from '../lib/lotto';
import { htmlLangTag } from '../lib/locale';
import { useAppLocale } from '../hooks/useAppLocale';

export function MatchInfoPanel({ match, rules, bonusName }: { match: MatchInfo; rules: GameRules; bonusName: string }) {
  const { t } = useTranslation();
  const locale = useAppLocale();
  const isJackpot = isJackpotMatch(rules, match);
  const allRegular = match.regularMatches === rules.regularCount;
  const isHigh = match.regularMatches >= rules.regularCount - 1;

  const summaryVars = { count: match.regularMatches, total: rules.regularCount, bonus: bonusName };
  const summary = match.bonusMatch ? t('match.summaryBonus', summaryVars) : t('match.summary', summaryVars);

  return (
    <div className={`match-info prestige-match ${isJackpot ? 'match-jackpot' : isHigh ? 'match-high' : ''}`}>
      <div className="match-info-header">
        {isJackpot && <span className="match-badge jackpot">{t('match.jackpot')}</span>}
        {!isJackpot && allRegular && <span className="match-badge high">{t('match.fiveNumbers')}</span>}
        <span>{summary}</span>
        <span className="match-date">
          — {match.round ? `${t('match.round', { round: match.round })} ` : ''}
          {formatMatchDate(match.date, htmlLangTag(locale))}
        </span>
      </div>
      <div className="match-numbers">
        {match.numbers.map((n) => (
          <span key={n} className={`match-num ${match.matchedNums.has(n) ? 'matched' : ''}`}>
            {n}
          </span>
        ))}
        <span className="match-plus">+</span>
        <span className={`match-num bonus-ball ${match.bonusMatch ? 'matched' : ''}`}>{match.bonus}</span>
      </div>
    </div>
  );
}
